var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 54,
  height: 54,
  viewBox: "0 0 54 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27.0017,
  cy: 26.9997,
  r: 23.1071,
  fill: "#EFE6FC",
  stroke: "#5F09E0",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27 15.4277L27 29.892",
  stroke: "#5F09E0",
  strokeWidth: 6,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 38.5713L27 39.5356",
  stroke: "#5F09E0",
  strokeWidth: 6,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-Icon.f39644a435850b425f4baf667953f6b0.svg";